var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Table } from 'template/lib';
import { BsTrash } from "react-icons/bs";
Modal.setAppElement('#root');
var ModalPendingCompany = function (props) {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), items = _c[0], setItems = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(10), pageSize = _e[0], setPageSize = _e[1];
    var _f = useState(1), totalPages = _f[0], setTotalPages = _f[1];
    var _g = useState(false), hasNext = _g[0], setHasNext = _g[1];
    var config = {
        headers: {
            Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token),
        },
    };
    useEffect(function () {
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
        }
    }, [login, handleLogout, history]);
    useEffect(function () {
        api.get('/companies/validationFinancial', config)
            .then(function (response) {
            var data = response.data;
            var formattedData = Array.isArray(data) ? data : [data];
            setItems(formattedData);
        })
            .catch(function (error) {
            var _a;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            setItems([]);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [props.isOpen, login === null || login === void 0 ? void 0 : login.token, page, pageSize]);
    var handleRemove = function (id) {
        var company = items.find(function (item) { return item.id === id; });
        var confirmed = window.confirm("Deseja realmente remover a empresa da lista de clientes com pend\u00EAncia financeira?\n\nEmpresa: " + company.wpsName + "\nDocumento: " + company.identityNumber);
        if (!confirmed)
            return;
        console.log('Removendo id:', id);
        api.delete("/companies/deleteClientFinancialPending/" + id, config)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                setItems(function (prev) { return prev.filter(function (item) { return item.id !== id; }); });
            }
        })
            .catch(function (error) {
            var _a, _b, _c;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            if ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.hasOwnProperty("detail")) {
                alert("Erro: " + error.response.data.detail);
                props.handleCloseModalPendingCompany();
            }
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var lineBtn = (login === null || login === void 0 ? void 0 : login.role) === 'Administrator'
        ? [
            {
                fn: handleRemove,
                icon: _jsx(BsTrash, { size: 16 }, void 0),
                name: 'Remover'
            }
        ]
        : [];
    return (_jsx(Modal, __assign({ isOpen: props.isOpen, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalPendingCompany, overlayClassName: "react-modal-overly", className: "react-modal-content", style: {
            content: {
                width: '90%',
                maxWidth: '800px',
                height: '85vh',
                margin: 'auto',
                padding: '20px',
                overflow: 'hidden',
                borderRadius: '4px'
            }
        } }, { children: _jsxs("div", __assign({ style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            } }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx(AiOutlineClose, { title: "Fechar", className: "cursor-pointer text-sm", onClick: props.handleCloseModalPendingCompany }, void 0)] }), void 0), _jsx("div", __assign({ style: {
                        flex: 1,
                        overflowY: 'auto',
                        marginTop: '10px'
                    } }, { children: _jsx(Table, { setSize: setPageSize, hasNext: hasNext, page: page, setPage: setPage, data: items, loading: loading, totalPAges: totalPages, lineButton: lineBtn, title: "Clientes com Pend\u00EAncia Financeira", columns: [
                            { label: 'WpsId', key: 'wpsId' },
                            { label: 'Empresa', key: 'wpsName', maxLenghtToShowSeeMore: 120 },
                            { label: 'Documento', key: 'identityNumber' },
                        ] }, void 0) }), void 0)] }), void 0) }), void 0));
};
export default ModalPendingCompany;
